<div class="wa-table-details">
  <table class="wa-table-inner">
    <tbody class="wa-table-inner__row-group">
      <tr class="wa-table-inner__row" *ngFor="let detail of details">
        <td class="wa-table-inner__cell wa-table-inner__cell--order-0 wa-table-inner__cell--wide">
          <div class="event">
            <div class="event__name">{{ detail.Stage === -1 ? ('FINAL' | transloco) : ('Stage' |transloco)+detail.Stage.toString() }}: </div>
            <a [href]="lang + 'competition/'+detail.ID.toString()" class="event__stage">{{ detail.NameShort !== '' && detail.NameShort ? detail.NameShort : detail.Name }}</a>
            <div class="event__img">
              <img
                [lazyLoad]="
                  '//extranet.worldarchery.sport/Flags/' +
                  detail.Country +
                  '.svg'
                "
              />
            </div>
          </div>
        </td>
        <td class="wa-table-inner__cell wa-table-inner__cell--right wa-table-inner__cell--order-2 wa-table-inner__cell--wide">
          <div class="date">
            {{ detail.Date | date: "d MMMM yyyy" | uppercase }}
          </div>
        </td>
        <td class="wa-table-inner__cell wa-table-inner__cell--order-1 wa-table-inner__cell--narrow">
          <div
            class="position"
            *ngIf="detail.Position > 3; else: medals"
          >
           {{detail.Position.toString()+calculatePosition(detail.Position)}}
        </div>
        </td>
        <td class="wa-table-inner__cell wa-table-inner__cell--order-1 wa-table-inner__cell--narrow">
          <ng-template #medals>
            <div
              class="position"
              [ngClass]="calculate_medals(detail.Position)"
            ></div>
          </ng-template>
        </td>
        <td class="wa-table-inner__cell wa-table-inner__cell--order-3 wa-table-inner__cell--narrow">
          <div
            class="score score--small"
            [ngClass]="detail.inTotal === true ? 'highlight' : ''"
          >
            {{ detail.Points }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
